import React from 'react'
import { useParams } from "react-router-dom"
import MuniSmartForm from '../../components/muni-components/muni-smart-form'

const SmartForm = () => {
    const { id, muniName } = useParams()
    const isPublic = true

    return (
        <>
            <MuniSmartForm id={id} muniName={muniName} isPublic={isPublic} />
        </>
    )
}

export default SmartForm